

export const galleryImages = [
    {
       src: "https://live.staticflickr.com/65535/52749643937_822de0f5a3_o.jpg",
       width: 3024,
       height: 4032,
       caption: "Frog riding a salamander -- witnessed while pitfall trapping to survey threatened California tiger salamanders",
       alt: "alt",
       customOverlay: (
         <div className="custom-overlay__caption">
           <div>Frog riding a salamander -- witnessed while pitfall trapping to survey threatened California tiger salamanders</div>
         </div>
       ),
    },

    {
       src: "https://live.staticflickr.com/65535/52750175041_142d501a9a_o.jpg",
       width: 3024,
       height: 4032,
       caption: "Rachel holding a salamander while pitfall trapping",
       alt: "alt",
       customOverlay: (
         <div className="custom-overlay__caption">
           <div>Rachel holding a salamander while pitfall trapping</div>
         </div>
       ),
    },

    {
      src: "https://live.staticflickr.com/65535/52749643697_6e7f8ee037_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Mantid found on Rachel's car",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Mantid found on Rachel's car</div>
         </div>
       ),
   },    
   
   {
      src: "https://live.staticflickr.com/65535/52750586665_a951b0e685_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Brown, gravid Pacific chorus frog",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Brown, gravid Pacific chorus frog</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750667833_2d60ee284a_o.jpg",
      height: 3024,
      width: 4032,
      caption: "The Stanford Foothills",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>The Stanford Foothills</div>
         </div>
      ),
   },
   {
      src: "https://live.staticflickr.com/65535/52749643827_b267efe102_o.jpg",
      height: 3024,
      width: 4032,
      caption: "Great egret flying over Lake Lagunita",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Great egret flying over Lake Lagunita</div>
         </div>
      ),
   },
 
   {
      src: "https://live.staticflickr.com/65535/52749643872_f379b237fb_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pacific chorus frog at the Dish",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pacific chorus frog at the Dish</div>
         </div>
      ),
   },

   {
    src: "https://live.staticflickr.com/65535/52749643852_1b6dab589a_o.jpg",
    width: 3024,
    height: 4032,
    caption: "Botta's pocket gopher near Lake Lagunita",
    alt: "alt",
    customOverlay: (
       <div className="custom-overlay__caption">
         <div>Botta's pocket gopher near Lake Lagunita</div>
       </div>
    ),
 },

   {
      src: "https://live.staticflickr.com/65535/52749643997_6314afa2c0_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pacific chorus frog at the Dish",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pacific chorus frog at the Dish</div>
         </div>
      ),
   },

   {
      src: "https://live.staticflickr.com/65535/52749644067_0294a1b3da_o.jpg",
      height: 3024,
      width: 4032,
      caption: "Invasive but beautiful mustard meadow",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Invasive but beautiful mustard meadow</div>
         </div>
      ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750666988_f61586c091_o.jpg",
      height: 3024,
      width: 4032,
      caption: "Family of deer in the Stanford Foothills",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Family of deer in the Stanford Foothills</div>
         </div>
      ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750419229_037da0eed3_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pacific chorus frog",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pacific chorus frog</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750586125_cc22203fc0_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Sunset over the Stanford Foothills",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Sunset over the Stanford Foothills</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750586080_b39c7a9c11_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Alligator lizard near Deer Creek",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Alligator lizard near Deer Creek</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750586145_252bc12e2e_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Lion's mane mushroom near Lake Lagunita",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Lion's mane mushroom near Lake Lagunita</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750667193_0ac762429f_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pacific chorus frog found in utility box survey",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pacific chorus frog found in utility box survey</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750174566_1179c60423_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Slender salamander",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Slender salamander</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750419419_f94272708a_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Juvenile Arboreal salamander",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Juvenile Arboreal salamander</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750174511_776ac26c5f_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Skink",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Skink</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750586315_3bb9068263_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Western toad tadpole (I call them toadpoles!)",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Western toad tadpole (I call them toadpoles!)</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750586335_758493dbd9_o.jpg",
      width: 3024,
      height: 4032,
      caption: "California newt found in utility box",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>California newt found in utility box</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750667433_dd11e93b7e_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pocket gopher skull, Stanford Foothills",
      alt: "alt"
   },
   {
      src: "https://live.staticflickr.com/65535/52750667463_448ec1a8a4_o.jpg",
      height: 3024,
      width: 4032,
      caption: "Pond in the Stanford Foothills",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pond in the Stanford Foothills</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750667543_036f441877_o.jpg",
      width: 3024,
      height: 4032,
      caption: "California kingsnake in the Stanford Foothills",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>California kingsnake in the Stanford Foothills</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750667558_df9556d3bb_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Barn swallow perched on streetlight on main campus",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Barn swallow perched on streetlight on main campus</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750174781_24a050bdb2_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pacific chorus frog chilling in a pond at the Dish",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pacific chorus frog chilling in a pond at the Dish</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750174811_17a480877f_o.jpg[",
      width: 3024,
      height: 4032,
      caption: "Deer spotted in grasslands",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Deer spotted in grasslands</div>
         </div>
       ),
   },

   {
      src: "https://live.staticflickr.com/65535/52750419689_7e6ae165ae_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Pacific chorus frog metamorph (halfway between tadpole and frog)",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Pacific chorus frog metamorph (halfway between tadpole and frog)</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750586615_7447d59a04_o.jpg",
      width: 3024,
      height: 4032,
      caption: "2 Gopher snakes found near Deer Creek",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>2 Gopher snakes found near Deer Creek</div>
         </div>
       ),
   },
   {
      src: "https://live.staticflickr.com/65535/52750174846_059ce62a3e_o.jpg",
      width: 3024,
      height: 4032,
      caption: "Rachel with gopher snake",
      alt: "alt",
      customOverlay: (
         <div className="custom-overlay__caption">
           <div>Rachel with gopher snake</div>
         </div>
       ),
   },
 ];

 export default galleryImages;